// Return codes that indicate there is a message to show for no order intake for booked out slots
export const RETURN_NO_ORDER_INTAKE_WITH_MESSAGE = ['RC6', 'RC7', 'RC8']
// Return codes that indicate there is a message to show for slot determination
export const RETURN_ORDER_INTAKE_WITH_MESSAGE = ['RC3', 'RC5']